import { FC } from "react";
import { SummaryCardProps } from "./types";

const SummaryCard: FC<SummaryCardProps> = ({
  count,
  title,
  high,
  mid,
  low,
  icon,
}) => {
  return (
    <div className="grid grid-cols-1 rounded-[8px] overflow-hidden ">
      <div className="flex flex-row items-center bg-[#3E4C66] border-b-1 border-b-white text-white px-[30px] py-[15px]">
        <img src={icon} />
        <div className="h-full w-[0.5px] bg-white opacity-[0.4] mx-4" />
        <span className="text-[12px] leading-[15px] text-center">
          <span className="text-[24px] mr-2">{count}</span>
          {title}
        </span>
      </div>
      <div className="grid grid-cols-3 px-[10px] py-[15px] bg-[#F1F6FF]">
        <div className="flex flex-col items-center justify-center">
          <span className="text-[#3D3C3AE5]">High</span>
          <span>{high}</span>
        </div>
        <div className="flex flex-col items-center justify-center border-r-1 border-l-1 border-g-200 border-opacity-[0.4]">
          <span className="text-[#3D3C3AE5]">Medium</span>
          <span>{mid}</span>
        </div>
        <div className="flex flex-col items-center justify-center">
          <span className="text-[#3D3C3AE5]">Low</span>
          <span>{low}</span>
        </div>
      </div>
    </div>
  );
};
export default SummaryCard;
